import { SORTING_TYPES } from '../constants';

export const between = (x: number, min: number, max: number) => (
  x >= min && x <= max
);

export const checkIsAscSorting = (sortingType: string = '') => (
  sortingType === SORTING_TYPES.ascending
);